import { InputAdornment } from '@material-ui/core';

import SearchIcon from '../assets/SearchIcon';

const InputAdornmentLeft = ({ className, children }) => {
  return (
    <InputAdornment className={className} position="start">
      {children || <SearchIcon />}
    </InputAdornment>
  );
};

export default InputAdornmentLeft;
